export const fieldList = {
  columnKeys() {
    return [
      { label: '大', key: 'daxiao_da' },
      { label: '小', key: 'daxiao_xiao' },
      { label: '和', key: 'daxiao_he' },
      { label: '单', key: 'danshuang_dan' },
      { label: '双', key: 'danshuang_shuang' }
    ]
  }
}
